import type {
  Channel,
  ChannelSelection,
  TacticSelection,
  UnitPriceType
} from './line-item-channels';

export type ConfigSelection = {
  channelId?: number;
  tacticId?: number;
  priceTypeId?: number;
};

export type AvailablePlatform = {
  id: number;
  name: string;
  hasAdapter: boolean;
  disabledReason: string | null;
};

export type LineItemConfigOptions = {
  availableChannels: ChannelSelection[];
  availableTactics: TacticSelection[];
  availablePriceTypes: UnitPriceType[];
  availablePlatforms: AvailablePlatform[];
};

export function lineItemConfigOptions(
  selection: ConfigSelection,
  channels: Channel[],
  hasAdapter: (platformId: number) => boolean
): LineItemConfigOptions {
  const channel =
    selection.channelId !== undefined
      ? channels.find(c => c.id === selection.channelId)
      : undefined;

  const availableTactics: TacticSelection[] = channel
    ? channel.tactics.map(t => ({ id: t.id, name: t.name }))
    : [];

  const tactic =
    channel && selection.tacticId !== undefined
      ? channel.tactics.find(t => t.id === selection.tacticId)
      : undefined;

  const availablePriceTypes: UnitPriceType[] = tactic ? tactic.rates.map(r => r.unitPriceType) : [];

  const availablePlatforms: AvailablePlatform[] = tactic
    ? tactic.platforms.map(p => {
        const enabled = hasAdapter(p.id);
        return {
          id: p.id,
          name: p.name,
          hasAdapter: enabled,
          disabledReason: enabled ? null : 'soon'
        };
      })
    : [];

  return {
    availableChannels: channels.map(c => ({ id: c.id, name: c.name })),
    availableTactics,
    availablePriceTypes,
    availablePlatforms
  };
}
